import React, { useState } from 'react';
import { useReveal } from '../lib/useReveal';
const FAQS = [{
  q: '¿Sirve si nunca estudié Reiki antes?',
  a: 'Sí. El Tomo 1 — El Despertar del Canal — está diseñado para empezar desde cero. No necesitás experiencia previa.'
}, {
  q: '¿Cómo recibo el material?',
  a: '100% digital. En menos de 5 minutos después de tu compra recibís acceso completo a todos los tomos y bonos en PDF.'
}, {
  q: '¿Puedo usarlo para enseñar a otros?',
  a: 'Sí. Con el MegaPack tenés todo el sistema para practicar y formar a tus propios alumnos.'
}, {
  q: '¿Tiene garantía real?',
  a: '7 días sin preguntas. Si no es lo que esperabas te devolvemos el 100%. Sin formularios. Sin drama.'
}];
export function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#FAFAF8] py-20 md:py-32 px-5 sm:px-6 border-t border-[#EAE6E1]" data-id="element-137">
      <div className="container mx-auto max-w-3xl" data-id="element-138">
        <div ref={ref1} className={`reveal text-center mb-16 ${vis1 ? 'is-visible' : ''}`} data-id="element-139">
          <h2 className="text-3xl md:text-5xl font-bold text-[#1E2330]" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-140">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-141">
          {FAQS.map((faq, idx) => <div key={idx} className="bg-white rounded-2xl border border-[#EAE6E1] overflow-hidden transition-all duration-300 shadow-[0_5px_20px_rgba(0,0,0,0.02)]" data-id="element-142">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full px-8 py-6 text-left flex items-center justify-between focus:outline-none" data-id="element-143">
                <span className="font-bold text-[#1E2330] text-lg pr-4" data-id="element-144">
                  {faq.q}
                </span>
                <span className={`text-[#D4AF37] text-3xl font-light transition-transform duration-300 ${openIdx === idx ? 'rotate-45' : ''}`} data-id="element-145">
                  +
                </span>
              </button>
              <div className={`px-8 overflow-hidden transition-all duration-300 ease-in-out ${openIdx === idx ? 'max-h-40 pb-8 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-146">
                <p className="text-[#4A5568] text-base leading-relaxed" data-id="element-147">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}